import {useGrpcRequest, useGrpcRequestCallback} from '@aboutyou/data-fetcher';
import {NavigationService_GetDrawerNavigationBulkLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.grpc.lazy';
import {GetDrawerNavigationBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.types';
import {useFullSession} from '@aboutyou/user';
import {useCallback} from 'react';
import {useReductionsStateRequestParameter} from '../../features/ReductionsState/useReductionsStateRequestParameter';
import {useSelectedTargetGroup} from '../../shared-deprecated/useSelectedTargetGroup';

export const useRequestDrawerNavigationCallback = () => {
  const {targetGroup} = useSelectedTargetGroup();
  const session = useFullSession();
  const reductionsState = useReductionsStateRequestParameter();

  const request = useGrpcRequestCallback(
    NavigationService_GetDrawerNavigationBulkLazy,
    {
      section: 'categoryTree',
    },
  );

  return useCallback(() => {
    if (!session) {
      return;
    }

    request({
      targetGroup,
      reductionsState,
      session,
    });
  }, [request, targetGroup, reductionsState, session]);
};

const useRequestDrawerNavigation = <
  Section extends keyof GetDrawerNavigationBulkResponse,
>(
  section: Section,
) => {
  const {targetGroup} = useSelectedTargetGroup();
  const session = useFullSession();

  return useGrpcRequest(
    NavigationService_GetDrawerNavigationBulkLazy,
    {
      targetGroup,
      reductionsState: useReductionsStateRequestParameter(),
      session: session!,
    },
    {
      retry: 3,
      section,
      /*
       * categoryTree relies on isStale to detect the transistion state - therefor data should never become stale without a gender-switch action
       */
      staleTime: Infinity,
      disabled: !session,
    },
  );
};

export const useRequestCategoryTree = () => {
  return useRequestDrawerNavigation('categoryTree');
};

export const useRequestTargetGroups = () => {
  return useRequestDrawerNavigation('targetGroups');
};

export const useRequestOffcanvasBanner = () => {
  return useRequestDrawerNavigation('banners');
};
